import styles from './HomePageHowItWorksVideo.module.css';

const BUCKET_NAME = `https://daymade-website-assets.s3.amazonaws.com/2026/homepage`;

const VIDEO_URL = `${BUCKET_NAME}/how-it-works.mp4`;

export const HomePageHowItWorksVideo = () => {
  return (
    <video autoPlay muted playsInline loop className={styles.video}>
      <source src={VIDEO_URL} type="video/mp4" />
    </video>
  );
};

export default HomePageHowItWorksVideo;
